/* eslint-disable no-unused-vars */
import { FC, RefObject } from "react";
import SearchRecent from "./search-recent";
import SearchSuggestResult from "./search-suggest-result";
import { SuggestResult } from "types/api/search";
import { ICON_SIZE, IconButton } from "@shared/components/icon-button";
import IconBackArrow from "@svg/header/back-arrow";
import classNames from "classnames";
import useSearchExperiments from "@shared/hooks/useSearchExperiments";
import FallingLoading from "legacy/elements/fallingLoading";
import { SearchInput } from "@shared/components/search-input";
import { useIsoMorphicEffect } from "@shared/hooks/useIsoMorphicEffect";

interface propTypes {
  searchValue: string;
  searchProductResult: SuggestResult | [];
  onClickCancel: () => void;
  closeHandler: () => void;
  onChangeInput?: (e: string) => void;
  onEnter?: (e: string) => void;
  onAction?: (e: string) => void;
  suggestKeyword?: string[];
  pending?: boolean;
  hasResult?: boolean;
  inputRef: RefObject<HTMLInputElement | null>;
  open: boolean;
}

const SearchPopUp: FC<propTypes> = ({
  onClickCancel,
  onChangeInput,
  onEnter,
  searchValue,
  onAction,
  suggestKeyword = [],
  pending,
  hasResult,
  searchProductResult,
  closeHandler,
  inputRef,
  open,
}) => {
  const searchExperimentSubmitter = useSearchExperiments();

  const onExperimentSubmitter = () => {
    searchExperimentSubmitter(searchValue);
  };

  useIsoMorphicEffect(() => {
    if (!open) return;

    const el = inputRef.current;
    if (!el) return;

    requestAnimationFrame(() => {
      el.focus({ preventScroll: true });

      const len = el.value.length;
      try {
        el.setSelectionRange(len, len);
      } catch {}
    });
  }, [open]);

  return (
    <div
      className={classNames(
        "fixed top-0 right-0 z-50 flex w-screen delay-300 transform flex-col justify-between overflow-y-auto overflow-x-hidden bg-fds-on-inverse shadow-lg ring-1 ring-black ring-opacity-5",
        open ? "opacity-100 translate-y-0 block" : "hidden translate-y-full"
      )}
    >
      <div className="mt-1.5 h-[100vh] w-full overflow-auto">
        <nav className="main-nav">
          <div className="w-full h-14 py-0.5 px-2 flex gap-1.5 items-center relative z-50 lg:hidden shadow-search-pop-up">
            <IconButton
              size={ICON_SIZE.SMALL}
              hideTooltip
              icon={<IconBackArrow />}
              onClick={closeHandler}
              aria-label="بستن"
            />
            <p className="font-medium leading-[26px]">جستجو</p>
          </div>

          <div className="absolute z-10 w-full rounded bg-fds-on-inverse py-6">
            <div className="w-full px-5">
              <SearchInput
                placeholder="جستجوی آموزش ..."
                onClickCancel={onClickCancel}
                onChangeInput={onChangeInput}
                onEnter={onEnter}
                searchValue={searchValue}
                withIcon
                focusTrigger={open}
                ref={inputRef}
              />
            </div>

            {!pending ? (
              !hasResult ? (
                <SearchRecent
                  onChange={(e) => {
                    onAction?.(e);
                    closeHandler();
                  }}
                />
              ) : (
                <SearchSuggestResult
                  searchProductResult={searchProductResult}
                  searchKeyword={suggestKeyword}
                  value={searchValue}
                  change={(e) => {
                    onAction?.(e);
                    closeHandler();
                  }}
                  close={closeHandler}
                  onExperimentSubmitter={onExperimentSubmitter}
                />
              )
            ) : (
              <FallingLoading />
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default SearchPopUp;
